module.exports = __webpack_public_path__ + "media/images/places/see-more-7e5d814a835f4487f5ac01a658aa1b31.png";